import { createContext, useContext, useRef } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { createAnalyticsStore } from './store';

const AnalyticsStoreContext = createContext(null);

export const useAnalyticsStoreContext = (selector, equalityFn) => {
  const context = useContext(AnalyticsStoreContext);

  if (!context) {
    throw new Error('useAnalyticsStoreContext must be used within a AnalyticsStoreContextProvider');
  }

  return useStoreWithEqualityFn(context, selector, equalityFn);
};

export const AnalyticsStoreProvider = ({ children }) => {
  const storeRef = useRef(null);

  if (storeRef.current === null) {
    storeRef.current = createAnalyticsStore();
  }

  return <AnalyticsStoreContext.Provider value={storeRef.current}>{children}</AnalyticsStoreContext.Provider>;
};
